module.exports = __webpack_public_path__ + "static/media/GPC_x3.1247704d.png";